module.exports = __webpack_public_path__ + "static/media/walkinsense_info_full.0de1d2e8.png";